import React, {useState, useEffect } from "react";
import axios from "axios";
import AddCart from "../addCart/AddCart";
import './tabla.css';
import carrito from '../img/carro-de-la-compra.png';
import jwtDecode from "jwt-decode";
import { getToken } from "../../../api/token";
import { siteURL, woocomPart, consumerKey, consumerSecret } from "../../../utils/constants";

export default function Variaciones(props) {

    const { idProducto, addProductCart } = props;
    const [iduser, setIduser] = useState(null);

    useEffect(() => {
      const token = getToken();
      if(token){
        setIduser(jwtDecode(token).data.user.id);
      }  
    }, [])
  



    const [datosProductos, setProductos] = useState();
  
    const ApiBrillos = async () => {
      let link = `${siteURL}${woocomPart}products/${idProducto}/variations?consumer_key=${consumerKey}&consumer_secret=${consumerSecret}&per_page=70`;
  
      let config = {
        method: "get",
        url: link,
        headers: {},
      };
  
      axios(config).then(function (response) {
        return setProductos(response.data);
      });
  
     // console.log(datosProductos);
    };
  
    useEffect(() => {
      ApiBrillos();
    }, []);
  
  
      const addCart = async(iduser,idProduct) =>{
  
        return AddCart(iduser,idProduct, idProducto);
        
      }
      if (iduser != null) {
    return (
      <tbody>
        {!datosProductos
          ? "cargando..."
          : datosProductos.map((datosProductos, index) => {
              return (
                <tr key={datosProductos.id}>
                  <td className="col-1">
                    <img
                      src={datosProductos.image.src}
                      className="img-circle"
                      width="100px"
                      height="100px"
                    />
                  </td>
                  <td className="col-1">{datosProductos.attributes[0].option}</td>
                  <td className="col-1" className="tablaPrecio">${datosProductos.price}</td>
                  <td className="col-4">
                    <button
                      className="btn btn-primary"
                      onClick={()=>addCart(iduser,datosProductos.id)}
                    >
                      <img style={{"width": "35px", "height": "35px", "align": "right"}} src={carrito}alt="" />
                    </button>
                  </td>
                </tr>
              );
            })}
      </tbody>
    );
    }else{
        return (
            <tbody>
              {!datosProductos
                ? "cargando..."
                : datosProductos.map((datosProductos, index) => {
                    return (
                      <tr key={datosProductos.id}>
                        <td className="col-1">
                          <img
                            src={datosProductos.image.src}
                            className="img-circle"
                            width="100px"
                            height="100px"
                          />
                        </td>
                        <td className="col-1">{datosProductos.attributes[0].option}</td>
                        <td className="col-1"  className="tablaPrecio">${datosProductos.price}</td>
                        <td className="col-4">
                          <button
                            className="btn btn-primary"
                            onClick={()=>addProductCart(datosProductos.id)}
                          >
                            <img style={{"width": "35px", "height": "35px", "align": "right"}} src={carrito}alt="" />
                          </button>
                        </td>
                      </tr>
                    );
                  })}
            </tbody>
          );
    }
}
